import { BaseMapper } from '../common/BaseMapper'

import { OrderTaxeAPI, OrderTaxeModel } from './type'

export class OrderTaxeMapper extends BaseMapper {
  apiMapper = (taxe: OrderTaxeAPI): OrderTaxeModel => ({
    id: taxe.id,
    price: taxe.price,
    type: taxe.type,
    title: taxe.title,
  })

  public static defaultValue: OrderTaxeModel = {
    id: 0,
    price: 0,
    type: '',
    title: '',
  }
}
